// extracted by mini-css-extract-plugin
export var overlay = "card-module--overlay--tZvqk";
export var group = "card-module--group--40zIC";